<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>{{ data?.bsb ? 'Edit' : 'Add' }} Banking Details</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<form (ngSubmit)="confirmPassword()" [formGroup]="editBankingInfoForm">
  <div mat-dialog-content>
    <div class="grid grid-cols-3 gap-x-20">
      <mat-form-field>
        <mat-label>BSB</mat-label>
        <input formControlName="bsb" matInput required maxlength="20" />
        <mat-error> BSB is <strong>required</strong> </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Account Number</mat-label>
        <input formControlName="accountNumber" matInput required maxlength="20" />
        <mat-error> Account Number is <strong>required</strong> </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Account Name</mat-label>
        <input formControlName="accountName" matInput required maxlength="64" />
        <mat-error> Account Name is <strong>required</strong> </mat-error>
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="mx-20!" />

  <mat-dialog-actions>
    <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
    <button
      matButton="elevated"
      class="red-button"
      type="submit"
      [disabled]="editBankingInfoForm.invalid || editBankingInfoForm.pristine || pending()">
      SAVE
    </button>
  </mat-dialog-actions>
</form>
